import React, { useState } from 'react'
import { Card, CloseButton } from 'react-bootstrap'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const OverlayCard = ({
    title,
    subtitle,
    text,
    className,
    children
}) => {
    const [show, setShow] = useState(true);

    return show ? (
        <Card className={classNames("video-overlay-card", { className })}>
            <Card.Body>
                <Card.Title>{title}</Card.Title>
                <Card.Subtitle>{subtitle}</Card.Subtitle>
                <Card.Text>{text}</Card.Text>
                <CloseButton onClick={() => setShow(false)} />
            </Card.Body>
            {children}
        </Card>
    ) : null;
}

OverlayCard.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.element
}

export default OverlayCard
